// Session teardown shared by explicit logout and by the API client
// when a refresh fails (the server no longer recognises the session).
//
// Clearing only the auth store is not enough: the TanStack Query
// cache still holds the previous user's listings (a different user
// logging in on the same tab would briefly see them), and running
// uploads would keep streaming bytes and then fail at finalize.

import { queryClient } from "@/queryClient";
import { useUploads } from "@/state/uploads";

import { useAuth } from "./stub";

/** Drop every piece of per-user client state. */
export function endSession(): void {
  useUploads.getState().abortAll();
  queryClient.clear();
  useAuth.getState().clear();
}
